import { FederalAgency } from './FederalAgency';

export const FederalAgencyOptions = [
    {
        id: FederalAgency.OfficeoftheComptrolleroftheCurrency,
        name: '1. Office of the Comptroller of the Currency (OCC)',
        shortName: 'OCC',
    },
    {
        id: FederalAgency.FederalReserveSystem,
        name: '2. Federal Reserve System (FRS)',
        shortName: 'FRS',
    },
    {
        id: FederalAgency.FederalDepositInsuranceCorporation,
        name: '3. Federal Deposit Insurance Corporation (FDIC)',
        shortName: 'FDIC',
    },
    {
        id: FederalAgency.NationalCreditUnionAdministration,
        name: '5. National Credit Union Administration (NCUA)',
        shortName: 'NCUA',
    },
    {
        id: FederalAgency.UnitedStatesDepartmentOfHousingandUrbanDevelopment,
        name: '7. United States Department of Housing and Urban Development (HUD)',
        shortName: 'HUD',
    },
    {
        id: FederalAgency.ConsumerFinancialProtectionBureau,
        name: '9. Consumer Financial Protection Bureau (Bureau)',
        shortName: 'Bureau',
    },
];
